import { render, staticRenderFns } from "./UploadOTA.vue?vue&type=template&id=50956b93&scoped=true"
import script from "./UploadOTA.vue?vue&type=script&lang=js"
export * from "./UploadOTA.vue?vue&type=script&lang=js"
import style0 from "./UploadOTA.vue?vue&type=style&index=0&id=50956b93&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50956b93",
  null
  
)

export default component.exports